<script lang="ts" setup>
import { usePageStore, useEventStore } from '@/stores'
import { useNow, useDateFormat } from '@vueuse/core'
import Breadcrumb from './components/Breadcrumb.vue'
import Section1 from './components/Section1.vue'
import Section2 from './components/Section2.vue'
import LazySection3 from './components/Section3.vue'
import Section4 from './components/Section4.vue'
import Section5 from './components/Section5.vue'
import Section6 from './components/Section6.vue'
import useSeo from './seo'

const pageStore = usePageStore()
const eventStore = useEventStore()
const show = ref(false)
await pageStore.fetchGetZonezone()

eventStore.fetchEventCalendar(useDateFormat(useNow(), 'YYYY-MM').value).then(() => {
  show.value = true
})

const zonezone = computed(() => pageStore.zonezone)
const calendar = computed(() => eventStore.calendar)

useSeo(zonezone.value)
</script>

<template>
  <div class="zonezoneArea">
    <Breadcrumb />
    <Section1 :data="zonezone?.infos.first_block" :title="zonezone?.infos.title"
      :description="zonezone?.infos.description" />
    <Section2 :data="zonezone?.infos.common_block" />
    <LazySection3 :data="calendar" v-if="show" />
    <Section4 :data="zonezone?.events" v-if="(zonezone?.events?.length ?? 0) > 0" />
    <Section5 :data="zonezone?.highlights" />
    <!-- <Section6 :data="zonezone?.infos.first_block" /> -->
  </div>
</template>

<style lang="scss" scoped>
.zonezoneArea {
  overflow: hidden;
  margin-left: toRem(-20);
  margin-right: toRem(-20);
  padding-left: toRem(20);
  padding-right: toRem(20);
}
</style>
